import { render, staticRenderFns } from "./TiltCardResed.vue?vue&type=template&id=07a12cb5&scoped=true&lang=pug"
import script from "./TiltCardResed.vue?vue&type=script&lang=js"
export * from "./TiltCardResed.vue?vue&type=script&lang=js"
import style0 from "./TiltCardResed.vue?vue&type=style&index=0&id=07a12cb5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a12cb5",
  null
  
)

export default component.exports